import FJIconButton from '../../../../common/components/FJIconButton/FJIconButton';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJFake3dAnimationContainer from '../FJFake3dAnimation/FJFake3dAnimationContainer';
import FJFake3dInput from '../FJFake3dInput/FJFake3dInput';
import styles from './FJFake3dEdit.module.less';
import PropTypes from 'prop-types';

const FJFake3dEdit = props => {
    const {
        uploadImg,
        uploadStatus,
        deepMapImage,
        originImage,
        previewImage,
        cancelDepthMapTask,
        onExport,
        isDraggingFile,
        setIsDraggingFile,
        openMediaLibrary,
    } = props;
    const isSmallComponent = !!deepMapImage.src;
    return (
        <>
            <FJFake3dInput
                uploadImg={uploadImg}
                uploadStatus={uploadStatus}
                isSmallComponent={isSmallComponent}
                originImage={originImage}
                previewImage={previewImage}
                cancelDepthMapTask={cancelDepthMapTask}
                isDraggingFile={isDraggingFile}
                setIsDraggingFile={setIsDraggingFile}
                openMediaLibrary={openMediaLibrary}
            />
            {isSmallComponent && (
                <>
                    <div className={styles.title}>{FJLocalStore._('animation-style')}</div>
                    <FJFake3dAnimationContainer />
                    <FJIconButton
                        className={styles.export_btn}
                        type={'gradient'}
                        text={FJLocalStore._('export')}
                        onClick={onExport}
                        textClassName={styles.export_text}
                    />
                </>
            )}
        </>
    );
};

FJFake3dEdit.propTypes = {
    uploadImg: PropTypes.func,
    uploadStatus: PropTypes.string,
    deepMapImage: PropTypes.object,
    originImage: PropTypes.object,
    previewImage: PropTypes.object,
    onExport: PropTypes.func,
    cancelDepthMapTask: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    openMediaLibrary: PropTypes.func,
};
export default FJFake3dEdit;
